module.exports = __webpack_public_path__ + "img/Frame werkwijze.2fb80455.jpg";